






































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateHoliday from "./create-holiday.vue";
import EditHoliday from "./edit-holiday.vue";
import Ajax from "../../lib/ajax";
import appconst from '../../lib/appconst';
import moment from "moment";
class PageHolidayRequest extends PageRequest {
    name: string;
}

@Component({
    components: { CreateHoliday, EditHoliday }
})
export default class Holidays extends AbpBase {
    edit() {
        this.editModalShow = true;
    }
    //filters
    pagerequest: PageHolidayRequest = new PageHolidayRequest();

    createModalShow: boolean = false;
    editModalShow: boolean = false;

    get holidayTypeDic() {
        return this.$store.state.common.holidayTypeDic;
    }

    get list() {
        return this.$store.state.holiday.list;
    }
    get loading() {
        return this.$store.state.holiday.loading;
    }
    create() {
        this.createModalShow = true;
    }
    pageChange(page: number) {
        this.$store.commit("holiday/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("holiday/setPageSize", pagesize);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        //filters

        await this.$store.dispatch({
            type: "holiday/getAll",
            data: this.pagerequest
        });
    }
    get pageSize() {
        return this.$store.state.holiday.pageSize;
    }
    get totalCount() {
        return this.$store.state.holiday.totalCount;
    }
    get currentPage() {
        return this.$store.state.holiday.currentPage;
    }
    columns = [
        {
            title: this.L("Name"),
            key: "name",
        },
        {
            title: this.L("HolidayType"),
            key: 'holidayType',
            render: (h:any,params:any) => {
                return h(
                    "span",
                    this.holidayTypeDic[params.row.holidayType]
                );
            }
        },
        {
            title: this.L('StartDate'),
            key: "startDate",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    moment(params.row.startDate).format('YYYY年MM月DD日')
                );
            }
        },
        {
            title: this.L('EndDate'),
            key: "endDate",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    moment(params.row.endDate).format('YYYY年MM月DD日')
                );
            }
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            width: 150,
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "Button",
                        {
                            props: {
                                type: "primary",
                                size: "small"
                            },
                            style: {
                                marginRight: "5px"
                            },
                            on: {
                                click: () => {
                                    this.$store.commit(
                                        "holiday/edit",
                                        params.row
                                    );
                                    this.edit();
                                }
                            }
                        },
                        this.L("Edit")
                    ),
                    h(
                        "Button",
                        {
                            props: {
                                type: "error",
                                size: "small",
                                disabled: params.row.isStatic
                            },
                            on: {
                                click: async () => {
                                    this.$Modal.confirm({
                                        title: this.L("Tips"),
                                        content: this.L(
                                            "HolidayDeleteWarningMessage"
                                        ),
                                        okText: this.L("Yes"),
                                        cancelText: this.L("No"),
                                        onOk: async () => {
                                            await this.$store.dispatch({
                                                type: "holiday/delete",
                                                data: params.row
                                            });
                                            await this.getpage();
                                        }
                                    });
                                }
                            }
                        },
                        this.L("Delete")
                    )
                ]);
            }
        }
    ];
    async created() {
        this.getpage();
    }
}
